// Helpers
import { errorLogger } from "@/Common/helpers/logger";

// Services
import { apiInstance, gql } from "@/services/httpAdapter";

// Types
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { IDrawModalities } from "@Settings/types/Common/model";
import { IMappedPosition } from "@Common/types/positions/api";

export type TGetMappedPositionsPto = {
	mappedPositions: IMappedPosition[];
	drawModalities: IDrawModalities[];
};
export async function getMappedPositionsPto(locationId: string) {
	const query = gql`
		query GetSystemSettings($locationId: String!, $filter: SystemSettingsFilter) {
			getSystemSettings(locationId: $locationId, filter: $filter) {
				mappedPositions {
					systemPosition
					isDepartmental
					ptoType {
						_id
						value
						modality
						modalityDefinition {
							frequency
							input
							value
							excludeHolidays
						}
					}
				}
				drawModalities {
					position
					drawModality
				}
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			ptoTypeByPosition: true,
		},
	};

	try {
		const response: GraphqlQueryResponse<"getSystemSettings", TGetMappedPositionsPto> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getSystemSettings;
	} catch (err) {
		errorLogger(err as Error);
		return null;
	}
}

type TGetPositionsPtoTypes = {
	position: string;
	payType: string[];
};
export async function getPositionsPtoTypes(locationId: string) {
	const query = gql`
		query GetPositionsPtoTypes($locationId: String!) {
			getPositionsPtoTypes(locationId: $locationId) {
				position
				payType
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<"getPositionsPtoTypes", TGetPositionsPtoTypes[]> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getPositionsPtoTypes;
	} catch (err) {
		errorLogger(err as Error);
		return null;
	}
}
